import { connect } from 'react-redux';
import localStorage from 'store';
import store from 'js/store';
import { submitEventToValues } from 'js/helpers/form';
import { signup, signupPremiumTrial, confirmAccount } from 'js/store/actions/auth';
import { mapLocalizationObjectToLocalizedText } from 'js/helpers/localization';
import { SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_NOT_SELECTED, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LARGE_SCALE_RENEWABLE, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMALL_SCALE_RENEWABLE, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LARGE_SCALE_EFFICIENCY, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_ELECTRIC_UTILITY, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_UNIVERSITY, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_CONSULTING_COMPANY, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LOCAL_GOVERNMENT_THINK_TANK, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMART_GRID_SERVICES, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMART_GRID_ANALYTICS, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_FINANCIAL, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_DEVELOPMENT_AGENCY, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_NON_PROFIT, SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_OTHER, SIGN_UP_PAGE_PARAM_TITLE_FIRST_NAME, SIGN_UP_PAGE_PARAM_TITLE_LAST_NAME, SIGN_UP_PAGE_PARAM_TITLE_EMAIL, SIGN_UP_PAGE_PARAM_TITLE_INSTITUTION_NAME, SIGN_UP_PAGE_PARAM_TITLE_INSTITUTION_TYPE } from 'js/constants/text';
import SignupPage from '.';
var SIGN_UP_PAGE_INSTITUTION_TYPE_OPTIONS = [{
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_NOT_SELECTED,
  value: ''
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LARGE_SCALE_RENEWABLE,
  value: 'large_scale_renewable'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMALL_SCALE_RENEWABLE,
  value: 'small_scale_renewable'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LARGE_SCALE_EFFICIENCY,
  value: 'large_scale_efficiency'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_ELECTRIC_UTILITY,
  value: 'electric_utility'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_UNIVERSITY,
  value: 'university'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_CONSULTING_COMPANY,
  value: 'consulting_company'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_LOCAL_GOVERNMENT_THINK_TANK,
  value: 'local_government_think_tank'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMART_GRID_SERVICES,
  value: 'smart_grid_services'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_SMART_GRID_ANALYTICS,
  value: 'smart_grid_analytics'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_FINANCIAL,
  value: 'financial'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_DEVELOPMENT_AGENCY,
  value: 'development_agency'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_NON_PROFIT,
  value: 'non_profit'
}, {
  title: SIGN_UP_PAGE_PARAM_OPTION_INSTITUTION_TYPE_OTHER,
  value: 'other'
}];
export default connect(function (state, ownProps) {
  var _state$authForms$sign = state.authForms.signup,
      isSubmitting = _state$authForms$sign.isSubmitting,
      errorMessage = _state$authForms$sign.errorMessage,
      successMessage = _state$authForms$sign.successMessage;
  return {
    isSubmitting: isSubmitting,
    formLabels: {
      firstName: mapLocalizationObjectToLocalizedText(SIGN_UP_PAGE_PARAM_TITLE_FIRST_NAME),
      lastName: mapLocalizationObjectToLocalizedText(SIGN_UP_PAGE_PARAM_TITLE_LAST_NAME),
      email: mapLocalizationObjectToLocalizedText(SIGN_UP_PAGE_PARAM_TITLE_EMAIL),
      password: 'Password',
      institutionName: mapLocalizationObjectToLocalizedText(SIGN_UP_PAGE_PARAM_TITLE_INSTITUTION_NAME),
      institutionType: mapLocalizationObjectToLocalizedText(SIGN_UP_PAGE_PARAM_TITLE_INSTITUTION_TYPE)
    },
    institutionTypeOptions: SIGN_UP_PAGE_INSTITUTION_TYPE_OPTIONS.map(function (option) {
      return Object.assign({}, option, {
        title: mapLocalizationObjectToLocalizedText(option.title)
      });
    }),
    messages: {
      error: errorMessage,
      success: successMessage
    },
    onSubmit: function onSubmit(event) {
      var values = submitEventToValues(event);
      var signupFunction = ownProps.premiumTrial ? signupPremiumTrial : signup;
      store.dispatch(signupFunction(values));
    },
    onConfirmAccount: function onConfirmAccount(event) {
      var values = submitEventToValues(event);
      store.dispatch(confirmAccount(values));
    },
    premiumTrial: ownProps.premiumTrial,
    user: localStorage.get('userAccount')
  };
})(SignupPage);